import { Controller } from "@hotwired/stimulus"

// Drives the step-2 workout editor's structural actions (add/delete segment or
// exercise). Instead of firing a bare link, each button submits the WHOLE
// workout form to the target endpoint, so the editor's in-progress names and
// timestamps are persisted server-side before the segment/exercise is created
// or destroyed. The server then re-renders the entire step-2 form, keeping the
// DOM in lock-step with the database.
//
// Attach to the form (data-controller="live-edit"); trigger from buttons with:
//   data-action="live-edit#submit"
//   data-live-edit-url-param="/admin/workouts/segment?id=1&segment_id=2"
//   data-live-edit-method-param="post" | "delete"
//   data-live-edit-stamp-param="true"   (adds only – appends the video timestamp)
export default class extends Controller {
  submit(event) {
    event.preventDefault()

    const form = this.element.matches("form") ? this.element : this.element.closest("form")
    if (!form) return

    // Commit any value still being typed (the timestamp controller syncs its
    // hidden field on focusout) before we serialize the form.
    this.flushActiveField()

    const { url, method = "post", stamp = false } = event.params
    form.action = stamp ? this.withTimestamp(url) : url
    this.setMethod(form, method)
    form.requestSubmit()
  }

  flushActiveField() {
    const active = document.activeElement
    if (active && typeof active.blur === "function") active.blur()
  }

  withTimestamp(url) {
    const timestamp = Math.floor(window.hoverTime ?? window.playbackTime ?? 0)
    return url + (url.includes("?") ? "&" : "?") + `timestamp=${timestamp}`
  }

  // Override the Rails method-override field so the existing PATCH form can be
  // submitted as POST (add) or DELETE (delete) to the right endpoint. Turbo
  // honours the _method hidden field for POST forms.
  setMethod(form, method) {
    let input = form.querySelector('input[name="_method"]')
    if (!input) {
      input = document.createElement("input")
      input.type = "hidden"
      input.name = "_method"
      form.appendChild(input)
    }
    input.value = method
  }
}
